import React from 'react'
import axios from 'axios'
import { useHistory } from 'react-router'
import { useLocale } from '@transifex/react'

import useEventListener from '../hooks/useEventListener'
import { useSelector } from 'react-redux'

type Props = {
  match: {
    params: { storageId: String },
  },
  location: { search: String },
}

const Storage = ({ match: { params }, location }: Props) => {
  const query = new URLSearchParams(location.search)
  const admin = useSelector((state) => state.collectionData.admin)

  const currentLocale = useLocale()
  const history = useHistory()
  useEventListener(window, 'message', (e) => {
    if (e.data) {
      try {
        const data = JSON.parse(e.data)

        if (data.name === 'userstabroute') history.push('/userstab', { lockId: location.state?.lockId })
      } catch {
        // ignore
      }
    }
  })

  const host = window.location.href.includes('staging') ? 'staging.qlocx.com/storage/iframe' : 'desktop-storage-iframe-app.s3-eu-west-1.amazonaws.com'

  const url = `https://${host}/index.html?authToken=${axios.defaults.headers.common.Authorization}&storageApi=${window.STORAGE_API}&storageId=${params.storageId}&view=${query.get('iframeRoute') || ''}&locale=${currentLocale}&adminEmail=${admin?.user?.email}&hasQinsightRole=${admin?.user?.roles?.includes('dataanalytics')}`

  return <iframe title="storage" src={url} style={{ width: '86vw', height: '80vh', border: 'none' }} />
}

export default Storage
